import { addressExists } from 'components/address-modal/utils';
import { ICommitDeliveryInput, IDeliveryAddress } from 'generated/graphql-gateway';
import { IUseCartTip } from 'state/order/hooks/use-cart-tip';
import { ServiceMode } from 'state/service-mode';
import { IPlaceAddress } from 'utils/geolocation';

interface IBuildCommitDeliveryInput {
  existingAddress: IDeliveryAddress[];
  deliveryAddress: IPlaceAddress | null;
  deliveryInstructions?: string;
  phoneNumber: string;
  serviceMode: ServiceMode;
  tipAmount: IUseCartTip['tipAmount'];
}

export const buildCommitDeliveryInput = ({
  existingAddress,
  deliveryAddress,
  deliveryInstructions,
  phoneNumber,
  serviceMode,
  tipAmount,
}: IBuildCommitDeliveryInput): ICommitDeliveryInput | null => {
  if (serviceMode !== ServiceMode.DELIVERY || !deliveryAddress) {
    return null;
  }

  const shouldSave = !addressExists(existingAddress, deliveryAddress);
  const alias = deliveryAddress.alias;
  const defaultInstruction = deliveryAddress.defaultInstruction;

  return {
    instructions: deliveryInstructions,
    tipCents: tipAmount,
    pushNotification: true,
    dropoff: {
      ...deliveryAddress,
      alias,
      defaultInstruction,
      shouldSave,
      phoneNumber,
    },
  };
};
